import makeStyles from '@mui/styles/makeStyles';
import {useCallback} from 'react';
import {theme} from '../../../../Theme';

export const useListStyles = (width: number) =>
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useCallback(
    makeStyles(() => {
      return {
        listRoot: {
          display: 'flex',
          minHeight: 'calc(100% - 68px)',
          flexDirection: 'column',
          flexShrink: 0,
          justifyContent: 'flex-start',
          [theme.breakpoints.down('sm')]: {
            justifyContent: 'space-between',
          },
          padding: width > 600 ? '20px 12px' : 0,
          width: width > 600 ? 250 : width,
          overflowX: 'hidden',
        },
        drawerItemHeading: drawerItemStyle(theme.palette.primary.main, 16),
        drawerItemRoot: drawerItemStyle(theme.palette.gray.dark, 14),
        drawerItemSelected: {
          backgroundColor: `${theme.palette.gray.light} !important`,
          borderRadius: 8,
          '& .MuiListItemText-primary': {
            fontWeight: 'bold',
            textDecoration: 'underline solid black 2px',
            textUnderlinePosition: 'under',
          },
          '& .MuiListItemIcon-root': {
            color: theme.palette.primary.main,
          },
        },
        drawerItemButton: {
          marginLeft: 20,
          marginBottom: 8,
        },
        avatar: {
          paddingBottom: 0,
          width: 25,
          height: 25,
          '& img': {
            borderRadius: 13,
            border: `1px solid ${theme.palette.secondary.main}`,
          },
          '& .MuiAvatar-fallback': {
            width: '100%',
            height: '100%',
            borderRadius: 13,
            padding: '6px',
            cursor: 'pointer',
          },
        },
      };
    }),
    [width],
  );

const drawerItemStyle = (color: string, size: number) => ({
  margin: '2px 0',
  padding: '6px 16px',
  color: color,
  size: `${size}px`,

  '& span': {
    lineHeight: 'inherit',
  },
  '& .MuiListItemIcon-root': {
    minWidth: 36,
  },

  '&:hover': {
    backgroundColor: `${theme.palette.gray.light} !important`,
    borderRadius: 8,
    '& .MuiListItemText-primary': {
      fontWeight: 'bold',
      textDecoration: 'none',
    },
    '& .MuiListItemIcon-root': {
      color: color,
    },
  },
});
